const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHematology(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BE1E2D",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M22.386,17.672 c-1.268-5.485-5.964-9.168-7.831-14.333c-0.037-0.174-0.133-0.345-0.197-0.511c-1.898,4.979-6.103,8.716-7.744,13.828 c-1.765,5.495,1.727,11.427,7.746,11.45C19.83,28.073,23.607,22.951,22.386,17.672z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C8100F"
    },
    d: "M15.489,25.709c-5.655-0.021-8.936-5.597-7.278-10.759c0.506-1.574,1.271-3.008,2.133-4.392 c-1.334,1.969-2.618,3.966-3.354,6.255c-1.658,5.163,1.623,10.736,7.278,10.759c3.19-0.019,5.767-1.881,6.989-4.477 C19.868,24.675,17.847,25.695,15.489,25.709z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E82E2D"
    },
    d: "M21.086,12.179"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#5BA5ED",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    points: "22.693,21.607 24.198,23.113  25.838,21.475 24.301,19.938  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5BA5ED",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M19.221,10.032 c-3.563,0-6.454,2.89-6.454,6.454c0,3.565,2.891,6.456,6.454,6.456c3.564,0,6.454-2.891,6.454-6.456 C25.675,12.921,22.785,10.032,19.221,10.032z M19.123,21.051c-2.521,0-4.563-2.045-4.563-4.565c0-2.52,2.043-4.563,4.563-4.563 s4.563,2.043,4.563,4.563C23.687,19.006,21.644,21.051,19.123,21.051z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      opacity: 0.2,
      fill: "#5BA5ED",
      stroke: "#2C355E",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    cx: 19.123,
    cy: 16.487,
    r: 4.564
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#2C355E",
      stroke: "#2C355E",
      strokeMiterlimit: 10
    },
    points: "28.823,23.611 26.227,21.016 23.63,23.613  26.226,26.209  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHematology);
export default __webpack_public_path__ + "static/media/hematology.594288699d2579c6541d6c35f02b467d.svg";
export { ForwardRef as ReactComponent };